"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingAuthorizationScreen = PendingAuthorizationScreen;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var data_table_1 = require("../../components/common/data-table");
var page_header_1 = require("../../components/common/page-header");
var orders_1 = require("../../features/apis/orders");
var use_error_handler_1 = require("../../hooks/use-error-handler");
function PendingAuthorizationScreen() {
    var _this = this;
    var _a;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _b = (0, use_error_handler_1.useErrorHandler)(), handleError = _b.handleError, handleSuccess = _b.handleSuccess;
    var _c = (0, react_2.useState)(1), page = _c[0], setPage = _c[1];
    var _d = (0, react_2.useState)(null), selectedOrder = _d[0], setSelectedOrder = _d[1];
    var _e = (0, react_2.useState)(""), rejectReason = _e[0], setRejectReason = _e[1];
    var _f = (0, react_1.useDisclosure)(), isRejectOpen = _f.isOpen, onRejectOpen = _f.onOpen, onRejectClose = _f.onClose;
    var _g = (0, orders_1.useGetPendingAuthorizationQuery)({ page: page, limit: 10 }), data = _g.data, isLoading = _g.isLoading, isFetching = _g.isFetching;
    var _h = (0, orders_1.useAuthorizeOrderMutation)(), authorizeOrder = _h[0], isAuthorizing = _h[1].isLoading;
    var _j = (0, orders_1.useRejectOrderMutation)(), rejectOrder = _j[0], isRejecting = _j[1].isLoading;
    var orders = ((_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.orders) || [];
    var totalPages = 1; // Pending orders are not paginated in the backend
    // Helper to get organization name from populated field
    var getOrgName = function (item) {
        if (item.organization_id && typeof item.organization_id === "object") {
            return item.organization_id.name || "-";
        }
        return "-";
    };
    // Helper to get product info from populated field
    var getProductDenomination = function (item) {
        if (item.product_id && typeof item.product_id === "object") {
            return item.product_id.denomination || 0;
        }
        return 0;
    };
    // Helper to get uploaded by name
    var getUploadedByName = function (item) {
        if (item.uploaded_by && typeof item.uploaded_by === "object") {
            var user = item.uploaded_by;
            return "".concat(user.name || "", " ").concat(user.surname || "").trim() || user.email || "-";
        }
        return "-";
    };
    var columns = [
        {
            key: "reference",
            label: "Reference",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "font-mono text-sm font-medium", children: item.reference_number }); },
        },
        {
            key: "organization",
            label: "Organization",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: getOrgName(item) }); },
        },
        {
            key: "total_recipients",
            label: "Recipients",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: item.total_recipients }); },
        },
        {
            key: "total_value",
            label: "Value",
            render: function (item) {
                var denomination = getProductDenomination(item);
                var totalValue = denomination * item.total_vouchers;
                return (0, jsx_runtime_1.jsxs)("span", { className: "font-medium", children: ["N$", (totalValue / 100).toFixed(2)] });
            },
        },
        {
            key: "uploaded_by",
            label: "Uploaded By",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: getUploadedByName(item) }); },
        },
        {
            key: "uploaded_at",
            label: "Date",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: new Date(item.uploaded_at || item.created_at).toLocaleDateString("en-ZA", { timeZone: "Africa/Johannesburg" }) }); },
        },
        {
            key: "actions",
            label: "Actions",
            align: "end",
            render: function (item) { return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-end gap-2", children: [item.is_own_upload && (0, jsx_runtime_1.jsx)("span", { className: "mr-2 rounded bg-warning-100 px-2 py-0.5 text-xs text-warning-700", children: "Your upload" }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", onPress: function () { return navigate("/orders/".concat(item._id)); }, children: "View" }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", color: "success", variant: "flat", onPress: function () { return handleAuthorize(item); }, isLoading: isAuthorizing && (selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder._id) === item._id, isDisabled: item.is_own_upload, title: item.is_own_upload ? "Cannot authorize your own upload" : "", children: "Authorize" }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", color: "danger", variant: "flat", isDisabled: item.is_own_upload, title: item.is_own_upload ? "Cannot reject your own upload" : "", onPress: function () {
                            setSelectedOrder(item);
                            onRejectOpen();
                        }, children: "Reject" })] })); },
        },
    ];
    var handleAuthorize = function (order) { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSelectedOrder(order);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, authorizeOrder({ id: order._id }).unwrap()];
                case 2:
                    _a.sent();
                    handleSuccess("Order authorized successfully");
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    handleError(error_1, { defaultMessage: "Failed to authorize order" });
                    return [3 /*break*/, 4];
                case 4:
                    setSelectedOrder(null);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleReject = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedOrder)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, rejectOrder({ id: selectedOrder._id, reason: rejectReason }).unwrap()];
                case 2:
                    _a.sent();
                    handleSuccess("Order rejected");
                    onRejectClose();
                    setRejectReason("");
                    setSelectedOrder(null);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    handleError(error_2, { defaultMessage: "Failed to reject order" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "space-y-6", children: [(0, jsx_runtime_1.jsx)(page_header_1.PageHeader, { title: "Pending Authorization", description: "Orders awaiting authorization. Note: You cannot authorize or reject orders you uploaded yourself (marked with 'Your upload').", actions: [
                    {
                        label: "Back to Orders",
                        variant: "bordered",
                        onClick: function () { return navigate("/orders"); },
                    },
                ] }), (0, jsx_runtime_1.jsx)(data_table_1.DataTable, { columns: columns, data: orders, isLoading: isLoading || isFetching, page: page, totalPages: totalPages, onPageChange: setPage, emptyContent: "No orders pending authorization" }), (0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isRejectOpen, onClose: onRejectClose, size: "md", disableAnimation: true, children: (0, jsx_runtime_1.jsxs)(react_1.ModalContent, { children: [(0, jsx_runtime_1.jsx)(react_1.ModalHeader, { children: "Reject Order" }), (0, jsx_runtime_1.jsxs)(react_1.ModalBody, { children: [(0, jsx_runtime_1.jsxs)("p", { className: "mb-4 text-sm text-default-500", children: ["Please provide a reason for rejecting order ", (0, jsx_runtime_1.jsx)("strong", { children: selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.reference_number })] }), (0, jsx_runtime_1.jsx)(react_1.Textarea, { label: "Rejection Reason", placeholder: "Enter reason for rejection", value: rejectReason, onValueChange: setRejectReason, isRequired: true })] }), (0, jsx_runtime_1.jsxs)(react_1.ModalFooter, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "bordered", onPress: onRejectClose, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: "danger", onPress: handleReject, isLoading: isRejecting, isDisabled: !rejectReason.trim(), children: "Reject Order" })] })] }) })] }));
}
